/**
 * SuggestedReferencesTabContainer.jsx
 *
 * Subscribes to backend V4 suggestions written to Y.Doc by ws-collaboration.
 */

import React, {useCallback, useEffect, useState} from 'react';
import SuggestedReferencesTab from './SuggestedReferencesTab';
import {useReferenceMarkData} from '../../../../hooks/useReferenceMarkData';

const SUGGESTION_FIELDS = {fields: ['suggestions', 'claims']};

export default function SuggestedReferencesTabContainer({
    referenceMarkId,
    cfg,
    onAddReference,
    onRemoveReference,
    onCountChange,
}) {
    const {
        suggestedReferences,
        suggestedReferencesStatus,
        suggestedReferencesError,
        claims,
        status: claimsStatus,
    } = useReferenceMarkData(referenceMarkId, SUGGESTION_FIELDS);

    const [dismissed, setDismissed] = useState(new Set());
    const [addedLocalIds, setAddedLocalIds] = useState(new Set());

    const dismissSuggestion = useCallback((localId) => {
        setDismissed((prev) => {
            const next = new Set(prev);
            next.add(localId);
            return next;
        });
    }, []);

    const filteredYMap = suggestedReferences.filter((s) => !dismissed.has(s.localId));

    useEffect(() => {
        onCountChange?.(filteredYMap.length);
    }, [filteredYMap.length, onCountChange]);

    const handleAdd = useCallback((citation) => {
        setAddedLocalIds((prev) => new Set(prev).add(citation.localId));
        onAddReference(citation);
        dismissSuggestion(citation.localId);
    }, [onAddReference, dismissSuggestion]);

    const handleRemove = useCallback((citation) => {
        dismissSuggestion(citation.localId);
        onRemoveReference?.(citation);
    }, [dismissSuggestion, onRemoveReference]);

    return (
        <SuggestedReferencesTab
            suggestedReferencesStatus={suggestedReferencesStatus}
            suggestedReferencesError={suggestedReferencesError}
            suggestedCitations={filteredYMap}
            addedLocalIds={addedLocalIds}
            claimsStatus={claimsStatus}
            claimsCount={claims?.length ?? 0}
            cfg={cfg}
            onAddReference={handleAdd}
            onRemoveReference={handleRemove}
        />
    );
}
